import React, {Component} from 'react';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default class PaginationComponent extends Component {
  constructor(props){
  	super(props);
  	this.onPageSelected = this.onPageSelected.bind(this);
  }

  onPageSelected() {
    this.props.callback(this.props.pageNumber);
  }

render() {
    var style=null;
    if(this.props.active){
      style={color:'white'};
    }
    return (
      <li onClick={this.onPageSelected}  style={{cursor: 'pointer'}}>
        <a className={classNames(this.props.active ? 'bg-theme-color' : '','')}
        style={style}>{this.props.pageNumber+1}</a>
      </li>
    );
  }

}
